import { CallQueueReportState } from "../interfaces/callQueueReport"
import { CallRatingState } from "../interfaces/callRating"
import { Types } from "../types"
import { CallQueueReportActions } from "../types/callQueueReport/actionType"
import { callRatingActions } from "../types/callRating/actionType"




const initialState: CallRatingState = {
    getCallRatingPending: false,
    getCallRatingSuccess: false,
    getCallRatingError: '',
    data: {},

    SetCallRatingPending: false,
    SetCallRatingSuccess: false,
    SetCallRatingError: '',

}


const callRatingReducer = (state = initialState, action: callRatingActions) => {
    switch (action.type) {
        case Types.GET_CALL_RATING_REQUEST:
            return {
                ...state,
                getCallRatingPending: true,
                getCallRatingSuccess: false,
                getCallRatingError: '',
                data: {},
            }

        case Types.GET_CALL_RATING_SUCCSEE:
            return {
                ...state,
                getCallRatingPending: false,
                getCallRatingSuccess: true,
                getCallRatingError: '',
                data: action.payload?.params,
            }
        case Types.GET_CALL_RATING_ERROR:
            return {
                ...state,
                getCallRatingPending: false,
                getCallRatingSuccess: false,
                getCallRatingError: action.payload,
            }
            case Types.GET_CALL_RATING_RESET:
                return {
                    ...state,
                    getCallRatingPending: false,
                    getCallRatingSuccess: false,
                    getCallRatingError: '',
                }    


        //***************************** */
        case Types.SET_CALL_RATING_REQUEST:
            return {
                ...state,
                SetCallRatingPending: true,
                SetCallRatingSuccess: false,
                SetCallRatingError: '',
            }

        case Types.SET_CALL_RATING_SUCCSEE:
            return {
                ...state,
                SetCallRatingPending: false,
                SetCallRatingSuccess: true,
                SetCallRatingError: '',
            }
        case Types.SET_CALL_RATING_ERROR:
            return {
                ...state,
                SetCallRatingPending: false,
                SetCallRatingSuccess: false,
                SetCallRatingError: action.payload,
            }

        default:
            return {
                ...state,
            }
    }
}

export default callRatingReducer